import { useContext } from 'react';

import { DrawerContext } from '@contexts/index';

export function useDrawer() {
  const context = useContext(DrawerContext);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useDrawer must be used within a DrawerProvider`);
  }

  const { state, setContent, openDrawer, closeDrawer, setTitle } = context;

  return { state, setContent, openDrawer, closeDrawer, setTitle };
}
